import React from "react";
import gql from "graphql-tag";
import { GiveSentence } from "@utils";
import { BrandModalLinkListItem } from "../BrandModalLinkListItem";
import { BrandModalInStoreLinkFragment } from "./__generated__/BrandModalInStoreLinkFragment";
// import styled from "@emotion/styled";

// == Types ================================================================
type TLink = BrandModalInStoreLinkFragment;

interface IProps {
  link: TLink;
  isFirst?: boolean;
  onClick: (linkId: string, locationId?: string) => void;
  locationId?: string;
}

// == Constants ============================================================

const FRAGMENTS = {
  fields: gql`
    fragment BrandModalInStoreLinkFragment on Link {
      id
      giveSentence
      positiveGiveAmount
      baselineGiveAmount
    }
  `,
};

const DEFAULT_PROPS = {
  isFirst: false,
};

// == Component ============================================================

const BrandModalInStoreLink = ({ locationId, link, onClick, isFirst }: IProps) => {
  const giveSentence = GiveSentence({
    positiveGiveAmount: link.positiveGiveAmount,
    baselineGiveAmount: link.baselineGiveAmount,
    giveSentence: link.giveSentence,
  });
  return (
    <BrandModalLinkListItem
      description="Activate this offer and use a linked payment card to purchase in-store."
      giveSentence={giveSentence}
      leftImage="https://flipgive.imgix.net/images/site/shop/brand-modal-in-store.png"
      linkId={link.id}
      locationId={locationId}
      showBorder={!isFirst}
      title="Shop In-Store"
      onClick={onClick}
    />
  );
};

BrandModalInStoreLink.fragments = FRAGMENTS;
BrandModalInStoreLink.defaultProps = DEFAULT_PROPS;

export default BrandModalInStoreLink;

// == Styles ===============================================================
